/**
 * 一键加购功能 - 特色产品区块
 * 处理 product-block-featured-products 中的一键加购按钮
 */

(function () {
  "use strict";

  // 防抖机制，避免重复点击
  let isAddingToCart = false;
  const addToCartDebounce = 1000; // 1秒内不能重复点击

  // 等待 DOM 加载完成
  document.addEventListener("DOMContentLoaded", function () {
    initQuickAddButtons();
    
    // 初始化购物车状态监听
    initCartStateListener();
  });

  // 初始化一键加购按钮
  function initQuickAddButtons() {
    const quickAddButtons = document.querySelectorAll(".quick-add-to-cart-btn");

    if (quickAddButtons.length === 0) return;

    quickAddButtons.forEach((button) => {
      button.addEventListener("click", handleQuickAddClick);
    });
  }

  // 处理一键加购点击事件
  function handleQuickAddClick(event) {
    event.preventDefault();
    event.stopPropagation();

    // 防抖检查
    if (isAddingToCart) {
      console.log("Please wait, adding to cart...");
      return;
    }

    const button = event.currentTarget;
    const productId = button.dataset.productId;
    const productTitle = button.dataset.productTitle;

    if (!productId) {
      console.error("Product ID not found");
      return;
    }

    // 设置防抖状态
    isAddingToCart = true;
    setTimeout(() => {
      isAddingToCart = false;
    }, addToCartDebounce);

    // 显示加载状态
    showLoadingState(button);

    // 调用加购方法
    addToCart(productId, productTitle, button);
  }

  // 显示加载状态
  function showLoadingState(button) {
    const btnImage = button.querySelector("img");
    const loadingWrap = button.querySelector(".btn__loading-wrap");

    // 禁用按钮并添加加载状态
    button.disabled = true;
    button.classList.add("loading");
    
    // 添加加载中的视觉反馈
    button.style.cursor = "not-allowed";

    // 使用setTimeout确保CSS过渡效果生效
    setTimeout(() => {
      // 显示加载动画
      if (loadingWrap) {
        loadingWrap.style.display = "flex";
        loadingWrap.style.justifyContent = "center";
        loadingWrap.style.alignItems = "center";
      }
    }, 50);
  }

  // 隐藏加载状态
  function hideLoadingState(button) {
    const btnImage = button.querySelector("img");
    const loadingWrap = button.querySelector(".btn__loading-wrap");

    // 先隐藏加载动画
    if (loadingWrap) {
      loadingWrap.style.display = "none";
    }

    // 恢复按钮状态
    button.disabled = false;
    button.classList.remove("loading");
    
    // 恢复视觉状态
    button.style.cursor = "pointer";
  }

  // 显示成功状态
  function showSuccessState(button) {
    const loadingWrap = button.querySelector(".btn__loading-wrap");
    
    if (loadingWrap) {
      // 创建成功图标
      const successIcon = document.createElement("div");
      successIcon.innerHTML = "✓";
      successIcon.style.cssText = `
        color: #4CAF50;
        font-size: 20px;
        font-weight: bold;
        animation: success-bounce 0.5s ease-out;
      `;
      
      // 清空加载动画内容并添加成功图标
      loadingWrap.innerHTML = "";
      loadingWrap.appendChild(successIcon);
    }
  }

  // 添加到购物车
  function addToCart(productId, productTitle, button) {
    // 检查是否有全局的 cart 对象
    if (
      typeof window.cart !== "undefined" &&
      typeof window.cart.addItemById === "function"
    ) {
      // 使用主题的 cart.addItemById 方法
      window.cart
        .addItemById(productId, 1)
        .then((response) => {
          // 显示成功状态
          showSuccessState(button);
          
          // 延迟后恢复正常状态
          setTimeout(() => {
            hideLoadingState(button);
            showSuccessMessage(productTitle);
          }, 500);

          // 触发购物车更新事件
          if (typeof window.r$1 === "function") {
            window.r$1("cart:updated");
            window.r$1("quick-cart:updated");
          }

          // 手动更新购物车数量显示
          updateCartCountDisplay();
          
          // 刷新购物车抽屉内容
          refreshQuickCartContent();

          // 如果有自定义事件系统，触发事件
          if (typeof window.dispatchCustomEvent === "function") {
            window.dispatchCustomEvent("cart:item-added", {
              productId: productId,
              productTitle: productTitle,
            });
          }
        })
        .catch((error) => {
          hideLoadingState(button);
          console.error("Add to cart error:", error);
        });
    } else {
      // 如果没有全局 cart 对象，使用 fetch 直接调用 Shopify API
      fetch("/cart/add.js", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: parseInt(productId),
              quantity: 1,
            },
          ],
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          // 显示成功状态
          showSuccessState(button);
          
          // 延迟后恢复正常状态
          setTimeout(() => {
            hideLoadingState(button);
            showSuccessMessage(productTitle);
          }, 500);

          // 触发购物车更新事件
          if (typeof window.r$1 === "function") {
            window.r$1("cart:updated");
            window.r$1("quick-cart:updated");
          }

          // 手动更新购物车数量显示
          updateCartCountDisplay();
          
          // 刷新购物车抽屉内容
          refreshQuickCartContent();

          // 如果有自定义事件系统，触发事件
          if (typeof window.dispatchCustomEvent === "function") {
            window.dispatchCustomEvent("cart:item-added", {
              productId: productId,
              productTitle: productTitle,
            });
          }
        })
        .catch((error) => {
          hideLoadingState(button);

          console.error("Add to cart error:", error);
        });
    }
  }

  // 显示成功消息
  function showSuccessMessage(productTitle) {
    // 获取当前购物车数量
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        // 创建成功提示
        const successMessage = document.createElement("div");
        successMessage.className = "quick-add-success-message";
        successMessage.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background: #4CAF50;
          color: white;
          padding: 15px 20px;
          border-radius: 5px;
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
          z-index: 10000;
          font-size: 14px;
          max-width: 300px;
          word-wrap: break-word;
        `;
        successMessage.innerHTML = `
          <div style="margin-bottom: 8px;">"${productTitle}" has been added to cart！</div>
        `;

        document.body.appendChild(successMessage);

        // 3秒后自动移除
        setTimeout(() => {
          if (successMessage.parentNode) {
            successMessage.parentNode.removeChild(successMessage);
          }
        }, 1000);
      })
      .catch((error) => {
        // 如果获取购物车信息失败，显示简化版消息
        const successMessage = document.createElement("div");
        successMessage.className = "quick-add-success-message";
        successMessage.style.cssText = `
          position: fixed;
          top: 20px;
          right: 20px;
          background: #4CAF50;
          color: white;
          padding: 15px 20px;
          border-radius: 5px;
          box-shadow: 0 4px 6px rgba(0,0,0,0.1);
          z-index: 10000;
          font-size: 14px;
          max-width: 300px;
          word-wrap: break-word;
        `;
        successMessage.textContent = `"${productTitle}" has been added to cart！`;

        document.body.appendChild(successMessage);

        // 3秒后自动移除
        setTimeout(() => {
          if (successMessage.parentNode) {
            successMessage.parentNode.removeChild(successMessage);
          }
        }, 1000);
      });
  }

  // 手动更新购物车数量显示
  function updateCartCountDisplay() {
    // 先给购物车数量添加更新状态
    const cartCounts = document.querySelectorAll("[data-js-cart-count]");
    cartCounts.forEach((cartCount) => {
      cartCount.classList.add("updating");
    });

    // 获取购物车数量
    fetch("/cart.js")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Failed to fetch cart data");
        }
        return response.json();
      })
      .then((cart) => {
        // 更新所有购物车数量显示
        cartCounts.forEach((cartCount) => {
          const oldCount = parseInt(cartCount.innerHTML) || 0;
          const newCount = cart.item_count;

          // 如果数量增加了，添加一个小的动画效果
          if (newCount > oldCount) {
            cartCount.style.transform = "scale(1.2)";
            cartCount.style.color = "#b79b7d";

            setTimeout(() => {
              cartCount.style.transform = "scale(1)";
              cartCount.style.color = "";
            }, 300);
          }

          cartCount.innerHTML = newCount;
          cartCount.classList.remove("updating");
        });

        // 更新购物车图标（如果有动画效果）
        const cartIcons = document.querySelectorAll("[data-js-cart-icon]");
        cartIcons.forEach((cartIcon) => {
          // 添加一个小的动画效果
          cartIcon.classList.add("cart-updated");
          setTimeout(() => {
            cartIcon.classList.remove("cart-updated");
          }, 300);
        });

        console.log("Cart count updated successfully:", cart.item_count);

        // 触发自定义事件，让其他组件知道购物车已更新
        if (typeof window.dispatchCustomEvent === "function") {
          window.dispatchCustomEvent("cart:count-updated", {
            oldCount:
              cartCounts.length > 0
                ? parseInt(cartCounts[0].innerHTML) || 0
                : 0,
            newCount: cart.item_count,
            cart: cart,
          });
        }
      })
      .catch((error) => {
        console.error("Failed to update cart count:", error);

        // 移除更新状态
        cartCounts.forEach((cartCount) => {
          cartCount.classList.remove("updating");
        });
      });
  }

  // 刷新购物车抽屉内容
  function refreshQuickCartContent() {
    console.log("Refreshing quick cart content...");
    
    // 方法1: 触发主题的购物车刷新事件
    if (typeof window.r$1 === "function") {
      window.r$1("quick-cart:updated");
      console.log("Triggered quick-cart:updated event");
    }
    
    // 方法2: 尝试调用主题的购物车刷新方法
    if (window.theme && window.theme.quickCart && typeof window.theme.quickCart.refreshQuickCart === 'function') {
      try {
        window.theme.quickCart.refreshQuickCart();
        console.log("Called theme.quickCart.refreshQuickCart()");
      } catch (error) {
        console.log("theme.quickCart.refreshQuickCart() failed:", error);
      }
    }
    
    // 方法3: 直接获取购物车HTML并更新内容
    setTimeout(() => {
      forceRefreshQuickCartHTML();
    }, 300);
  }
  
  // 强制刷新购物车HTML内容
  function forceRefreshQuickCartHTML() {
    const quickCart = document.querySelector('.quick-cart');
    if (!quickCart) {
      console.log("Quick cart not found");
      return;
    }
    
    // 获取购物车section ID
    const sectionId = quickCart.getAttribute('data-section-id');
    if (!sectionId) {
      console.log("Quick cart section ID not found");
      return;
    }
    
    // 构建请求URL
    const url = `/cart?section_id=${sectionId}`;
    
    console.log("Fetching cart HTML from:", url);
    
    fetch(url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then(html => {
        console.log("Cart HTML received, updating content...");
        
        // 解析HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // 查找购物车容器
        const newQuickCart = doc.querySelector('.quick-cart');
        if (!newQuickCart) {
          console.log("New quick cart not found in response");
          return;
        }
        
        // 检查购物车状态变化
        const currentHasItems = quickCart.querySelector('.quick-cart__form') !== null;
        const newHasItems = newQuickCart.querySelector('.quick-cart__form') !== null;
        const currentHasEmptyState = quickCart.querySelector('.quick-cart__empty-state') !== null;
        const newHasEmptyState = newQuickCart.querySelector('.quick-cart__empty-state') !== null;
        
        console.log("Cart state - Current has items:", currentHasItems, "New has items:", newHasItems);
        console.log("Cart state - Current has empty state:", currentHasEmptyState, "New has empty state:", newHasEmptyState);
        
        // 如果状态发生变化，需要完全替换内容
        if (currentHasItems !== newHasItems || currentHasEmptyState !== newHasEmptyState) {
          console.log("Cart state changed, replacing entire content");
          replaceEntireQuickCartContent(quickCart, newQuickCart);
        } else {
          // 状态相同，只更新内容
          updateQuickCartContent(quickCart, newQuickCart);
        }
        
        console.log("Quick cart content refresh completed");
      })
      .catch(error => {
        console.error("Failed to refresh cart HTML:", error);
      });
  }
  
  // 替换整个购物车内容（当状态发生变化时）
  function replaceEntireQuickCartContent(quickCart, newQuickCart) {
    const cartContainer = quickCart.querySelector('.quick-cart__container');
    if (!cartContainer) {
      console.log("Cart container not found");
      return;
    }
    
    // 保留头部，替换其他内容
    const header = cartContainer.querySelector('.quick-cart__header');
    const newHeader = newQuickCart.querySelector('.quick-cart__header');
    
    // 清空容器内容（除了头部）
    const children = Array.from(cartContainer.children);
    children.forEach(child => {
      if (!child.classList.contains('quick-cart__header')) {
        child.remove();
      }
    });
    
    // 添加新的内容
    const newChildren = Array.from(newQuickCart.querySelector('.quick-cart__container').children);
    newChildren.forEach(child => {
      if (!child.classList.contains('quick-cart__header')) {
        cartContainer.appendChild(child.cloneNode(true));
      }
    });
    
    // 更新头部
    if (header && newHeader) {
      header.innerHTML = newHeader.innerHTML;
    }
    
    console.log("Entire cart content replaced successfully");
  }
  
  // 更新购物车内容（当状态相同时）
  function updateQuickCartContent(quickCart, newQuickCart) {
    // 检查购物车是否有商品
    const hasItems = newQuickCart.querySelector('.quick-cart__form') !== null;
    const hasEmptyState = newQuickCart.querySelector('.quick-cart__empty-state') !== null;
    
    if (hasItems) {
      // 购物车有商品，更新商品列表
      const cartItems = quickCart.querySelector('.quick-cart__items');
      const newCartItems = newQuickCart.querySelector('.quick-cart__items');
      
      if (cartItems && newCartItems) {
        cartItems.innerHTML = newCartItems.innerHTML;
        console.log("Cart items updated successfully");
      }
      
      // 更新购物车表单
      const cartForm = quickCart.querySelector('.quick-cart__form');
      const newCartForm = newQuickCart.querySelector('.quick-cart__form');
      
      if (cartForm && newCartForm) {
        cartForm.innerHTML = newCartForm.innerHTML;
        console.log("Cart form updated successfully");
      }
      
    } else if (hasEmptyState) {
      // 购物车为空，更新空购物车状态
      const emptyState = quickCart.querySelector('.quick-cart__empty-state');
      const newEmptyState = newQuickCart.querySelector('.quick-cart__empty-state');
      
      if (emptyState && newEmptyState) {
        emptyState.innerHTML = newEmptyState.innerHTML;
        console.log("Empty cart state updated successfully");
      }
    }
    
    // 更新购物车头部（数量）
    const cartHeader = quickCart.querySelector('.quick-cart__header');
    const newCartHeader = newQuickCart.querySelector('.quick-cart__header');
    
    if (cartHeader && newCartHeader) {
      cartHeader.innerHTML = newCartHeader.innerHTML;
      console.log("Cart header updated successfully");
    }
  }

  // 监听动态加载的内容
  function observeDynamicContent() {
    if (typeof MutationObserver !== "undefined") {
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === "childList" && mutation.addedNodes.length > 0) {
            // 检查新添加的节点中是否有加购按钮
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === Node.ELEMENT_NODE) {
                const newButtons = node.querySelectorAll
                  ? node.querySelectorAll(".quick-add-to-cart-btn")
                  : [];
                if (newButtons.length > 0) {
                  newButtons.forEach((button) => {
                    if (!button.hasAttribute("data-quick-add-initialized")) {
                      button.addEventListener("click", handleQuickAddClick);
                      button.setAttribute("data-quick-add-initialized", "true");
                    }
                  });
                }
              }
            });
          }
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  // 初始化动态内容监听
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", observeDynamicContent);
  } else {
    observeDynamicContent();
  }

  // 初始化购物车状态监听
  function initCartStateListener() {
    console.log("Initializing cart state listener...");
    
    // 等待购物车组件加载
    setTimeout(() => {
      const quickCart = document.querySelector('.quick-cart');
      if (quickCart) {
        // 使用MutationObserver监听购物车状态变化
        const observer = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              // 检查购物车是否打开
              if (quickCart.classList.contains('is-open') || 
                  quickCart.classList.contains('active') ||
                  quickCart.style.display !== 'none') {
                console.log('Quick cart opened, auto-refreshing content...');
                // 购物车打开时自动刷新内容
                setTimeout(() => {
                  forceRefreshQuickCartHTML();
                }, 200);
              }
            }
          });
        });
        
        observer.observe(quickCart, {
          attributes: true,
          attributeFilter: ['class', 'style']
        });
        
        console.log('Cart state listener initialized successfully');
      } else {
        console.log('Quick cart not found, retrying...');
        // 如果购物车还没加载，稍后重试
        setTimeout(initCartStateListener, 1000);
      }
    }, 1000);
  }
})();
